module.exports = __webpack_public_path__ + "3c6c2b1829eb42fdeb797e757d37b758.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/testPages/listening_test/assets/model.png
// module id = 718
// module chunks = 0